import React from 'react';
import SearchTypeahead from './SearchTypeahead';
import Icons from 'components/atoms/Icons';
import {
  OnQueryInputChangeType,
  UpdateQueryType,
} from 'components/types/FilterTypes';

type SearchFilterProps = {
  minimumCharacters: number;
  onQueryInputChange: OnQueryInputChangeType;
  placeholder: string;
  queryInputValue: string;
  searchType: string;
  updateQuery: UpdateQueryType;
  isMobile?: boolean;
};

const SearchFilter = (props: SearchFilterProps) => {
  const {
    minimumCharacters,
    onQueryInputChange,
    placeholder,
    queryInputValue,
    searchType,
    updateQuery,
    isMobile,
  } = props;

  return (
    <div className="search-input search-text-box">
      <div
        className={
          searchType === 'locations'
            ? 'search-icon-wrapper locations'
            : 'search-icon-wrapper'
        }
        onClick={() => {
          props.updateQuery(props.queryInputValue);
        }}
      >
        <Icons id="icon-search-green" className="icon-search" />
      </div>
      <SearchTypeahead
        minimumCharacters={minimumCharacters || 2}
        onQueryInputChange={onQueryInputChange}
        placeholder={placeholder}
        queryInputValue={queryInputValue}
        searchType={searchType}
        updateQuery={updateQuery}
        isMobile={isMobile}
      />
    </div>
  );
};

export default SearchFilter;
